@if (availableStageOptions()) {
  <glxy-form-field [hideRequiredLabel]="true">
    <glxy-label>{{ 'OPPORTUNITY.STAGE.SELECTOR.LABEL' | translate }}</glxy-label>
    <mat-select
      [formControl]="control"
      (blur)="saveField()"
      [placeholder]="'OPPORTUNITY.STAGE.SELECTOR.TITLE' | translate"
      [@autoFill]="autoFillState()"
    >
      <mat-option *ngFor="let pipelineOption of availableStageOptions()" [value]="pipelineOption.id">
        {{ pipelineOption.name }}
      </mat-option>
    </mat-select>
    <glxy-error *ngIf="!control.untouched && control?.hasError('required')">
      {{ 'STANDARD_FIELD_RULES.OPPORTUNITY.STAGE_REQUIRED' | translate }}
    </glxy-error>
  </glxy-form-field>
} @else {
  <div class="stencil-shimmer"></div>
}
